import Reveal from "@/components/feature/Reveal";
import { featuredFlash, flashNews } from "@/mocks/homeFlashNews";
import { tagClass } from "@/pages/home/tagStyles";

export default function FlashNews() {
  return (
    <section id="flash" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-10 md:px-8 md:py-14">
        <Reveal>
          <div className="mb-6 flex items-end justify-between">
            <div>
              <span className="text-xs font-medium tracking-widest text-accent-700">LIVE FEED</span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                最新实锤快讯
              </h2>
            </div>
            <a
              href="#timeline"
              className="hidden cursor-pointer items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700 sm:inline-flex"
            >
              查看完整时间线
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <article className="flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="relative h-52 w-full sm:h-60 lg:h-64">
                <img
                  src={featuredFlash.image}
                  alt="海角黑料截图证据集中整理示意图"
                  title="海角黑料实锤证据截图汇总"
                  className="h-full w-full object-top"
                />
                <span
                  className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-medium ${tagClass(
                    featuredFlash.tag
                  )}`}
                >
                  {featuredFlash.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950">
                  {featuredFlash.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {featuredFlash.summary}
                </p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-stack-line"></i>
                    {featuredFlash.materials} 份材料
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-time-line"></i>
                    {featuredFlash.updatedAt}
                  </span>
                </div>
              </div>
            </article>
          </Reveal>

          <Reveal className="lg:col-span-7" delay={80}>
            <ul className="h-full overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {flashNews.map((item, index) => (
                <li
                  key={item.id}
                  className={`flex items-start gap-3 px-4 py-3.5 transition-colors hover:bg-background-100 md:px-5 ${
                    index !== 0 ? "border-t border-background-200" : ""
                  }`}
                >
                  <span
                    className={`mt-0.5 shrink-0 rounded-md px-2 py-0.5 text-xs font-medium ${tagClass(
                      item.tag
                    )}`}
                  >
                    {item.tag}
                  </span>
                  <p className="flex-1 text-sm leading-relaxed text-foreground-800">{item.text}</p>
                  <span className="shrink-0 whitespace-nowrap text-xs text-foreground-400">
                    {item.time}
                  </span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}